import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";

const AppFileImput = ({
  tooltip,
  file_name,
  placeholder,
  handleFileUpload,
  handleClearFile,
  error,
  allowedFIle,
  size,
  name,
  fullWidth = false,
  sx,
  helperText = "",
  disabled = false,
}) => {
  const [fileName, setFileName] = useState(file_name);

  const handleClear = () => {
    setFileName("");
    inputRef.current.value = "";
    handleClearFile();
  };

  useEffect(() => {
    setFileName(file_name);
  }, [file_name]);
  const inputRef = useRef();
  return (
    <>
      <Tooltip
        title={
          fileName ||
          tooltip ||
          placeholder ||
          "Cliquer pour choisir un fichier"
        }
      >
        <TextField
          disabled={disabled}
          placeholder={placeholder || "Choisir un fichier"}
          variant="outlined"
          size={size}
          error={error || false}
          helperText={helperText || ""}
          fullWidth={fullWidth}
          sx={{
            ...sx,
            "& .MuiInputBase-input": {
              textAlign: "right",
            },
          }}
          value={fileName || ""}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Button
                  disabled={disabled}
                  component="label"
                  // variant="outlined"
                  startIcon={<AttachFileIcon />}
                >
                  {placeholder || "Choisir un fichier"}
                  <input
                    type="file"
                    hidden
                    name={name}
                    onChange={handleFileUpload}
                    accept={
                      allowedFIle || ".jpeg,.jpg,.png,.pdf,.zip,.xls*,.docx"
                    }
                    ref={inputRef}
                  />
                </Button>
              </InputAdornment>
            ),
            endAdornment: (
              <Tooltip title="Supprimer fichier selectionné">
                <InputAdornment
                  disabled={disabled}
                  position="end"
                  style={{ display: fileName ? "flex" : "none" }}
                >
                  <IconButton onClick={handleClear}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              </Tooltip>
            ),
          }}
        />
      </Tooltip>
    </>
  );
};

export default AppFileImput;
